import { makeAutoObservable } from 'mobx';
import {auth} from 'main/tools';

class AttachmentFormState {
  question;
  showAttachmentOptions;
  folders = [];

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({question, showAttachmentOptions, folders}) {
    this.question = question;
    this.showAttachmentOptions = showAttachmentOptions;
    this.folders = folders;

    this.question.args = {};
  }

  get showFolderSelector() {
    return auth.hasAccess('::MANAGE_DOCUMENTS') || auth.hasAccess('::MANAGE_FOLDERS') || auth.viewData('::DOCUMENTS');
  }
}

export default AttachmentFormState;
